module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-LightItalic-8e5d97df7fe2b6714ec0110f1eaeb2ce.woff";